enum FeatureTypes {
  SUBMITTALS = 1,
  MATERIALS = 2,
  BUYOUT = 3,
  BID_PACKAGE = 4,
  DESIGN_PACKAGE = 5,
  PLANNING_ONLY_SUBMITTAL = 6,
  PLANNING_ONLY_MATERIAL = 7,
  PLANNING_ONLY_ACTIVITY = 8,
  ACTIVITIES = 9,
  DESIGN_SCOPE = 10
}

enum LinkTypes {
  finish_to_start = 0,
  start_to_start = 1,
  finish_to_finish = 2,
  start_to_finish = 3
}

const FeatureIdTemplateMapping: { [key: number]: string } = {
  1: "Submittal",
  2: "Material",
  4: "Bid Package",
  5: "Design Package"
};

const FeatureRouteSlugMapping: { [key: number]: string } = {
  1: "submittals",
  2: "materials",
  4: "bid-packages",
  5: "design-packages"
};

const FeatureTypeStringMapping: { [key: number]: string } = {
  1: "SUBMITTALS",
  2: "MATERIALS",
  4: "BID_PACKAGE",
  5: "DESIGN_PACKAGE"
};

const Priorities = [
  { label: "Low", value: "Low" },
  { label: "Normal", value: "Normal" },
  { label: "High", value: "High" }
];

export {
  FeatureTypes,
  LinkTypes,
  FeatureIdTemplateMapping,
  FeatureRouteSlugMapping,
  FeatureTypeStringMapping,
  Priorities
};
